const appOutdated = (
  $location,
  $rootScope,
  $timeout,
  $window,
  appEvents,
  uimessages,
  APP_EVENTS,
) => {
  'ngInject';

  const removeOutdateEvent = appEvents.on(APP_EVENTS.outdated, () => {
    const queryToAdd = 'updated=true';
    const absUrl = $location.absUrl();
    const separator = absUrl.match(/\?\w+=/) ? '&' : '?';
    $window.location.href = `${absUrl}${separator}${queryToAdd}`;
  });

  appEvents.once(APP_EVENTS.start, () => {
    if ($location.search().updated === 'true') {
      $timeout(() => {
        uimessages.notification(
          'A new version of the application has been released',
          {
            type: 'info',
            expiration: 5000,
          },
        );
      });

      $location.url($location.path());
    }
  });

  $rootScope.$on('$destroy', () => {
    removeOutdateEvent();
  });
};

export default appOutdated;
